import * as React from 'react';
import Org from '../../../models/Org';
import omit from 'lodash/fp/omit';
import classNames from 'classnames';

/** Stylesheet Imports */
import styles from './OrgSwitcher.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input } from 'antd';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';

export interface OrgSwitcherProps {
  orgs: Org[];
  currentOrgId: string;
  visible?: boolean;
  onCreateOrgClick: any;
}

export default class OrgSwitcher extends React.Component<OrgSwitcherProps> {
  state = {
    query: '',
  };

  renderOrgList = () => {
    const { orgs, currentOrgId } = this.props;
    const { query } = this.state;
    const filteredOrgs = query ? orgs.filter((org) => org.name.toLowerCase().indexOf(query.toLowerCase()) > -1) : orgs;

    return filteredOrgs.map((org) => {
      return <OrgSwitcherItem key={org._id} {...omit('members', org)} current={org._id === currentOrgId} />;
    });
  };

  handleSearch = (e: any) => {
    this.setState({ query: e.target.value });
  };

  render() {
    const { query } = this.state;
    return (
      <div className={styles.orgSwitcher}>
        <Input.Search className="gigg-input" placeholder="Filter..." onChange={this.handleSearch} value={query} />
        <ul className={styles.orgSwitcherList}>{this.renderOrgList()}</ul>
        <div className="margin-top-sm">
          <button className="btn btn-primary" onClick={this.props.onCreateOrgClick}>
            Create New Organization
          </button>
        </div>
      </div>
    );
  }
}

function OrgSwitcherItem(props: { current: boolean; name: string; url: string }) {
  const classes = classNames(styles.orgSwitcherItem, { [styles.orgSwitcherItemActive]: props.current });

  return (
    <li className={classes}>
      {!props.current && (
        <a className={styles.orgSwitcherItemInner} href={`/${props.url}`}>
          <h3 className={styles.orgSwitcherItemTitle}>{props.name}</h3>
          <div className={styles.orgSwitcherItemIcon}>
            <FontAwesomeIcon className="pull-right" icon={faArrowRight} />
          </div>
        </a>
      )}
      {props.current && (
        <div className={styles.orgSwitcherItemInner}>
          <h3 className={styles.orgSwitcherItemTitle}>{props.name}</h3>
          <div className={styles.orgSwitcherItemIcon}>
            <FontAwesomeIcon className="pull-right" icon={faArrowRight} />
          </div>
        </div>
      )}
    </li>
  );
}
